<template>
  <div class="edit_table" :style="editTableStyle">
    <div class="edit_table_head">
      <div :style="rankTableStyle">
        <table class="rank_table" :style="getRankTdStyle">
          <colgroup>
            <col :width="rankSize.width + 'px'" />
          </colgroup>
          <tr>
            <td></td>
          </tr>
          <tr>
            <td></td>
          </tr>
        </table>
      </div>
      <div class="edit_table_head_scroll_bar">
        <el-scrollbar ref="headScrollbar" :style="titleSize">
          <div class="table_box" :style="titleWrapper">
            <table :style="tableHead">
              <colgroup>
                <col v-for="(item, index) in colSize" :key="index" :width="item + 'px'" />
              </colgroup>
              <tr>
                <td class="head_text text_td" v-for="(item, index) in calcXArr" :key="index">
                  {{ item }}
                </td>
              </tr>
              <tr class="fixed_table_head">
                <td class="head_text text_td" v-for="(headName, index) in calcTableHeadData" :key="index">
                  <span>{{ headName.includes(uuid) ? "" : headName }}</span>
                </td>
              </tr>
            </table>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div class="edit_table_content">
      <div :style="rankTableStyle">
        <table class="rank_table" :style="getRankTdStyle">
          <colgroup>
            <col :width="rankSize.width + 'px'" />
          </colgroup>

          <tr v-for="(item, index) in trTopEnd - trTopStart" :key="index" :style="rankStyleTextStyle">
            <td class="table_rank" @click="clickRank(item, index)">
              {{ index + trTopStart + 1 }}
            </td>
          </tr>
        </table>
      </div>
      <div>
        <el-scrollbar ref="contentScrollbar" :style="contentBarBoxSize">
          <div class="table_box" :style="contentTableWrapper">
            <table :style="tableContent" class="table_content">
              <colgroup>
                <col v-for="(item, index) in colSize" :key="index" :width="item + 'px'" />
              </colgroup>
              <tr class="content_tr" v-for="(row, rowIndex) in calcTableData" :key="rowIndex">
                <div class="del_box" :style="delBox(rowIndex)">
                  <div @click="delRow(rowIndex)" class="del_btn"><div class="icon-portal-minus"></div></div>
                </div>
                <div :style="{ width: colSize.reduce((b, c) => b + c) - 1 + 'px', height: contentSize.height + 'px' }">
                  <td
                    class="text_td"
                    v-for="(col, index) in row"
                    :key="index"
                    @click="activeTd"
                    @dblclick="changeInputMode"
                  >
                    <div class="content_box" :tabindex="index">
                      <input
                        type="text"
                        :value="col[1] === uuid ? '' : col[1]"
                        @change="changeInputVal(rowIndex, index, col[0], $event)"
                      />
                      <p class="content_text">{{ col[1] === uuid ? "&nbsp;" : col[1] }}</p>
                    </div>
                  </td>
                </div>
              </tr>
            </table>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import { xArr, tableHeadSize, contentSize, rankSize, trLength, tableWidth, colLen } from "./utils"
export default {
  name: "editTable",
  props: {
    tableData: {
      type: Array,
      required: true
    },
    maxRow: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      tdLeftStart: 0,
      tdLeftEnd: 5,
      trTopStart: 0,
      trTopEnd: 10,
      maxShowTrLen: 10,
      scrollL: 0,
      scrollT: 0,
      rankLeft: 0,
      elScrollTop: 0,
      elShow: false,
      showDelBox: false,
      inputEl: null,
      selectRow: []
    }
  },
  computed: {
    uuid() {
      return String(new Date().getTime()).slice(6)
    },
    delBox() {
      return function (rowIndex) {
        return {
          width: (this.elShow ? this.$el.offsetWidth : contentSize.width * colLen) - rankSize.width + "px",
          height: contentSize.height + "px",
          display: this.selectRow.find(item => item === rowIndex + this.trTopStart) ? "flex" : "none"
        }
      }
    },
    getRankTdStyle() {
      return { width: rankSize.width + "px", paddingLeft: 0, paddingRight: 0 }
    },
    rankStyleTextStyle() {
      return {
        paddingLeft: "0",
        paddingRight: "0",
        lineHeight: "100%",
        textAlign: "center",
        height: contentSize.height + "px"
      }
    },
    rankTableStyle() {
      return {
        width: rankSize.width + "px"
      }
    },
    rankSize() {
      return rankSize
    },
    contentSize() {
      return contentSize
    },
    contentTableWrapper() {
      return {
        width: xArr.length * contentSize.width + rankSize.width + "px",
        height: this.maxRow * contentSize.height + 4 + "px",
        position: "relative"
      }
    },
    titleWrapper() {
      return {
        left: -this.rankLeft + "px",
        top: this.elScrollTop + "px",
        width: xArr.length * contentSize.width + rankSize.width + "px",
        height: tableHeadSize.height * 2 + "px",
        position: "relative"
      }
    },
    tableHead() {
      return {
        left: this.scrollL + "px",
        width: tableWidth + "px",
        position: "absolute",
        height: tableHeadSize.height * 2 + "px"
      }
    },
    tableContent() {
      return {
        left: this.scrollL + "px",
        top: this.scrollT + "px",
        width: tableWidth + "px",
        position: "absolute",
        height: contentSize.height * trLength + "px"
      }
    },
    contentBarBoxSize() {
      return {
        width: contentSize.width * colLen + "px",
        height: contentSize.height * this.maxShowTrLen + "px"
      }
    },
    titleSize() {
      return {
        width: contentSize.width * colLen + "px",
        height: rankSize.height * 2 + "px"
      }
    },
    editTableStyle() {
      return {
        "--tdHeight": contentSize.height + "px",
        "--tdWidth": contentSize.width + "px",
        "--textWidth": contentSize.width - 18 + "px",
        "--rightBarLine": (this.elShow ? this.$el.offsetWidth : contentSize.width * colLen) - rankSize.width - 4 + "px"
      }
    },
    colSize() {
      return new Array(colLen).fill(1).map((item, index) => {
        return contentSize.width
      })
    },
    calcXArr() {
      return this.calcTd(xArr)
    },
    calcTableHeadData() {
      const realKeys = this.completeTableData[0].map(item => item[0])
      return this.calcTd(realKeys)
    },
    //先计算出完整的二维数组
    completeTableData() {
      const newData = JSON.parse(JSON.stringify(this.tableData))
      const emptyRow = [] //一整个空行
      for (let i = 0; i < xArr.length; i++) {
        emptyRow.push([`a${this.uuid}${i}`, this.uuid])
      }
      const emptyCol = [] //单行中 除去已有的行 需要不充的行内容
      for (let i = 0; i < xArr.length - newData[0]?.length || 0; i++) {
        emptyCol.push([`a${this.uuid}${i}`, this.uuid])
      }
      return newData
        .map(row => {
          return row.concat(emptyCol)
        })
        .concat(new Array(this.maxRow - newData.length).fill(JSON.parse(JSON.stringify(emptyRow))))
    },
    //根据视窗大小和进度条位置进行二维数组的裁切
    calcTableData() {
      return this.calcTr(
        this.completeTableData.map(rowArr => {
          return this.calcTd(rowArr)
        })
      )
    }
  },
  methods: {
    delRow(index) {
      this.$emit("change", "delete", index + this.trTopStart)
      this.$nextTick(() => {
        this.selectRow.splice(
          this.selectRow.findIndex(item => item === index + this.trTopStart),
          1
        )
      })
    },
    clickRank(item, index) {
      const realIndex = index + this.trTopStart
      const indexInSelectRow = this.selectRow.findIndex(item => item === realIndex)
      if (indexInSelectRow !== -1) {
        this.selectRow.splice(indexInSelectRow, 1)
      } else {
        this.selectRow.push(realIndex)
      }
    },
    /**
     * @param {number} rowIndex 在表格二维数组中第几行
     * @param {number} colIndex 在表格二维数组中第几列
     * @param {string} key 在第rowindex行的colindex列中，的键名
     * @param {event} event 事件
     */
    changeInputVal(rowIndex, colIndex, key, event) {
      const value = event.target.value
      event.target.value = ""
      if (key.includes(this.uuid)) {
        //键名带uuid 证明是新增操作
        this.$emit(
          "change",
          "create",
          rowIndex + this.trTopStart,
          colIndex + this.tdLeftStart,
          key.includes(this.uuid) ? undefined : key,
          value
        )
      } else {
        // 否则就是更新操作
        this.$emit(
          "change",
          "update",
          rowIndex + this.trTopStart,
          colIndex + this.tdLeftStart,
          key.includes(this.uuid) ? undefined : key,
          value
        )
      }
    },
    calcTd(array) {
      return array.slice(this.tdLeftStart, this.tdLeftEnd)
    },
    calcTr(array) {
      return array.slice(this.trTopStart, this.trTopEnd)
    },
    activeTd(e) {
      const tar = e.target.className.includes("content_box") ? e.target : e.target.parentNode
      if (this.inputEl === tar) return
      this.clearInput()
      this.inputEl = tar
      this.inputEl.style.background = "var(--cellSelectBgColor)"
      this.inputEl.style.border = "1px solid var(--selectBorderColor)"
    },
    clearInput(index, e) {
      //清除上一次选中的效果
      if (this.inputEl) {
        this.inputEl.getElementsByTagName("p")[0].style.display = "block"
        this.inputEl.getElementsByTagName("input")[0].style.display = "none"
        this.inputEl.removeAttribute("style")
        this.inputEl = null
      }
    },
    changeInputMode(e) {
      this.clearInput()
      //双击后显示input框
      this.inputEl = e.target.className.includes("content_box") ? e.target : e.target.parentNode
      this.inputEl.getElementsByTagName("p")[0].style.display = "none"
      this.inputEl.getElementsByTagName("input")[0].style.display = "block"
      this.inputEl.getElementsByTagName("input")[0].focus({
        preventScroll: true
      })
      this.inputEl.style.border = "1px solid var(--selectBorderColor)"
    },

    handleScrollbarEv(e) {
      this.clearInput()
      const { scrollTop, scrollLeft } = e.target
      this.rankLeft = scrollLeft
      this.leftControl(scrollLeft)
      this.topControl(scrollTop)
    },
    //横向移动处理函数
    leftControl(scrollLeft) {
      const hidTdLen = scrollLeft / contentSize.width
      if (hidTdLen > this.tdLeftStart && Math.floor(hidTdLen) > this.tdLeftStart) {
        //向右拉超过一格
        this.scrollL = scrollLeft
        this.tdLeftStart = Math.floor(hidTdLen)
        this.tdLeftEnd = colLen + Math.floor(hidTdLen)
      }
      if (hidTdLen < this.tdLeftStart && Math.ceil(hidTdLen) <= this.tdLeftStart) {
        //向左拉超过一格
        this.scrollL = scrollLeft - contentSize.width
        this.tdLeftStart = Math.floor(hidTdLen)
        this.tdLeftEnd = colLen + Math.floor(hidTdLen)
      }
      if (this.scrollL < 0) {
        this.scrollL = 0
      }
    },
    //纵向移动处理函数
    topControl(scrollTop) {
      this.scrollT = scrollTop
      const tdH = contentSize.height
      const _tds = Math.floor((scrollTop - rankSize.width) / tdH)
      this.trTopStart = _tds >= 0 ? _tds : 0
      this.trTopEnd = this.maxShowTrLen + (_tds >= 0 ? _tds : 0)
    },
    initScrollbarEventListener() {
      this.$refs.contentScrollbar.wrap.addEventListener("scroll", this.handleScrollbarEv)
    },
    removeScrollEventListener() {
      this.$refs.contentScrollbar.wrap.removeEventListener("scroll", this.handleScrollbarEv)
    },
    initEditTableBarRightLineControl() {
      this.$el.addEventListener("mouseover", this.handleEditTableBarRightLinePosition)
    },
    handleEditTableBarRightLinePosition() {
      this.elShow = true
      this.$el.removeEventListener("mouseover", this.handleEditTableBarRightLinePosition)
    },
    initHeadScrollLineControl() {
      const self = this
      function handleScroll(e) {
        const { scrollTop } = e.target
        self.elScrollTop = scrollTop
      }
      this.$refs.headScrollbar.handleScroll = handleScroll.bind(this.$refs.headScrollbar)
    }
  },
  mounted() {
    //监听el-scrollbar的原生滚动事件
    this.initScrollbarEventListener()
    //处理纵向滚动条的位置
    this.initEditTableBarRightLineControl()
    //处理el-scrollbar组件内部滚动条监听事件
    this.initHeadScrollLineControl()
  },
  beforeDestroy() {
    this.removeScrollEventListener()
  }
}
</script>

<style scoped>
.edit_table {
  position: relative;
}
.edit_table_head {
  text-align: center;
  display: flex;
  flex-direction: row;
}
.head_text {
  padding: 2.5px 8px;
}
tr {
  height: var(--tdHeight);
}
td,
th {
  border-top: 1px solid var(--borderColorNine);
  border-right: 1px solid var(--borderColorNine);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
}
table.rank_table {
  border-left: 1px solid var(--borderColorNine);
}
.edit_table_content .rank_table,
.edit_table_content .el-scrollbar {
  border-bottom: 1px solid var(--borderColorNine);
}
/* td > div:focus {
  background: var(--cellSelectBgColor);
  border: 1px solid var(--selectBorderColor);
} */
td > div {
  border: 1px solid transparent;
}
td > div > p {
  display: block;
}
td > div > input {
  width: var(--textWidth);
  display: none;
  color: var(--textColor);
  background-color: transparent;
}
.content_box {
  padding: 4.5px 6px;
  width: 100%;
  height: 92%;
}
.fixed_table_head {
  text-align: left;
}
.content_tr {
  position: relative;
  display: block;
}
.del_box {
  position: absolute;
  left: 0;
  top: 0;
  background: var(--cellSelectBgColor);
  border-top: 1px solid var(--selectBorderColor);
  border-bottom: 1px solid var(--selectBorderColor);
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.del_box > div {
  height: 100%;
  background-color: rgba(255, 78, 78, 0.4);
  border: 1px solid #ff4e4e;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.text_td {
  height: var(--tdHeight);
  width: var(--tdWidth);
  vertical-align: top;
}
.content_text {
  width: var(--textWidth);
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
.edit_table {
  overflow: hidden;
}
.edit_table_content {
  display: flex;
  flex-direction: row;
}
::v-deep .is-vertical {
  left: var(--rightBarLine);
}
.edit_table_head_scroll_bar ::v-deep .is-vertical {
  display: none;
}
.edit_table_head_scroll_bar ::v-deep .is-horizontal {
  display: none;
}
.del_btn:hover {
  cursor: pointer;
}
.table_rank:hover {
  cursor: pointer;
}
</style>
